import React, { useState,useEffect } from 'react'
import {Box,Heading,Text } from 'grommet'
import { withRouter } from 'react-router-dom';
import DashboardCards from '../components/dashboardCards'
import {ReturnGreeting} from '../components/utils/shared/shared'
import { ShipmentSuccessNotification } from '../components/utils/shared/shipmentViewFunctions';
import { User } from 'grommet-icons';
import moment from 'moment'

function Dashboard (props) {
  const [dgNotification, setDgNotification] = useState(props.location.dgNotification)
    useEffect(() => {
    setTimeout(() => {
      setDgNotification(undefined);
    }, 5000)
  },[]);
  return (
    <Box> 
        <Box direction='row' justify='between' border='bottom'>
           <Box margin={{top:'medium', right:'small', left:'medium'}} direction='row'><Box margin={{top:'xsmall'}}><User color='brand' /></Box><Text margin='small' size='small'>{ReturnGreeting(props.username, moment().format('H'))}</Text></Box>
           <Heading margin={{right: 'medium'}} level={3}>Dashboard</Heading>
        </Box>
        {dgNotification && (<ShipmentSuccessNotification label={"Dangerous Goods Enquiry"} edit={false} />)}
        <DashboardCards customer={props.lab} user={props.user} />
    </Box>
  )
}

export default withRouter(Dashboard)
